import { ReduxState } from 'interfaces';
import React, { forwardRef, useState } from 'react';
import { FaImage, FaRegIdCard } from 'react-icons/fa';
import { connect, ConnectedProps } from 'react-redux';
import { LuScanFace, LuFileCheck2, LuLifeBuoy } from 'react-icons/lu';
import { Alert, Button } from '30pay/components';
import { BsCamera, BsImage } from 'react-icons/bs';
import CameraCaptureModal from '30pay/wallet/deposit/methods/offline/cameraModal/cameraModal.index';
import { objectToFormData, post, postFormData, userProfile } from 'scripts';
import { API } from 'data/30pay.api';
import successImage from 'assets/images/success.png';
import { Link } from 'react-router-dom';
import { PATH } from 'data/30pay.path';
import HintImage from 'assets/images/selfieImageHint.png';
import { __ProfessionalManualVerifyContentProps, __ProfessionalManualVerifyContentRef } from './manualVerify.interface';
import { Image } from 'antd';

export interface ProfessionalManualVerifyContentRef extends __ProfessionalManualVerifyContentRef { }
const ProfileProfessionalManualVerifyModalContent: React.ForwardRefRenderFunction<
    __ProfessionalManualVerifyContentRef,
    __ProfessionalManualVerifyContentProps
> = (props: __ProfessionalManualVerifyContentProps, ref) => {
    const [step, setStep] = useState(1);
    const [frontCapturedImage, setFrontCapturedImage] = useState<File | null>(null);
    const [frontSelectedImage, setFrontSelectedImage] = useState<File | null>(null);
    const [backCapturedImage, setBackCapturedImage] = useState<File | null>(null);
    const [backSelectedImage, setBackSelectedImage] = useState<File | null>(null);
    const [selfieCapturedImage, setSelfieCapturedImage] = useState<File | null>(null);
    const [selfieSelectedImage, setSelfieSelectedImage] = useState<File | null>(null);
    const [isCameraModalOpen, setIsCameraModalOpen] = useState(false);
    const [activeCamera, setActiveCamera] = useState<'front' | 'back' | 'selfie'>('front');
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    React.useImperativeHandle(ref, () => ({
        getIsSuccess: () => isSuccess,
    }));

    const handleCapture = (image: File) => {
        if (activeCamera === 'front') {
            setFrontSelectedImage(null);
            setFrontCapturedImage(image);
        } else if (activeCamera === 'back') {
            setBackSelectedImage(null);
            setBackCapturedImage(image);
        } else {
            setSelfieSelectedImage(null);
            setSelfieCapturedImage(image);
        }
        setIsCameraModalOpen(false);
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, side: 'front' | 'back' | 'selfie') => {
        const file = event.target.files?.[0];
        if (file) {
            if (side === 'front') {
                setFrontCapturedImage(null);
                setFrontSelectedImage(file);
            } else if (side === 'back') {
                setBackCapturedImage(null);
                setBackSelectedImage(file);
            } else {
                setSelfieCapturedImage(null);
                setSelfieSelectedImage(file);
            }
        }
    };

    const handleSubmit = () => {
        setLoading(true);
        const body = {
            // frontPic: frontSelectedImage || frontCapturedImage,
            // backPic: backSelectedImage || backCapturedImage,
            SelfiePic: selfieSelectedImage || selfieCapturedImage,
        };

        postFormData(API.level.uploadFilesUpgradeTo2, objectToFormData(body))
            .then(() => {
                setIsSuccess(true);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (isSuccess) {
        return (
            <div className="flex flex-col items-center gap-3">
                <img src={successImage} alt="success" className="w-full h-full" />
                <p className="text-xl font-bold text-positive-dark">اطلاعات احراز هویت شما با موفقیت ثبت شد.</p>
                <p className="text-base font-medium text-black-100 text-center">
                    اطلاعات شما طی ۱۲ ساعت آینده بررسی خواهد شد.
                </p>
                <div className="flex items-center gap-4 w-full mt-6">
                    <Link className="flex-1" to={PATH.dashboard}>
                        <Button className="w-full" type="primary">
                            برگشت به داشبورد
                        </Button>
                    </Link>
                    <Button className="flex-1 bg-background" type="text" onClick={props.onClose}>
                        بستن
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <>
            <CameraCaptureModal
                isOpen={isCameraModalOpen}
                onClose={() => setIsCameraModalOpen(false)}
                onCapture={handleCapture}
            />
            {step === 1 ? (
                <div className="flex flex-col">
                    <p className="text-sm font-medium text-black-100 mb-6">
                        به منظور افزایش امنیت حساب کاربری و رعایت الزامات قانونی، انجام احراز هویت برای استفاده از خدمات صرافی ۳۰پی الزامی است.                    </p>
                    <div className="flex flex-col gap-4">
                        <label className="font-bold text-base text-darkPurple-100">مراحل احراز هویت حرفه‌ای:</label>
                        {/* <div className="flex items-center gap-3">
                            <div className="rounded-full w-12 h-12 bg-background border border-primary-20 flex items-center justify-center">
                                <FaRegIdCard size={24} className="text-primary-100" />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="font-bold text-sx text-black-60">مرحله اول:</label>
                                <p className="text-black-100 font-bold text-sm">بارگذاری تصویر کارت ملی</p>
                            </div>
                        </div> */}
                        <div className="flex items-center gap-3">
                            <div className="rounded-full min-w-12 min-h-12 max-w-12 max-h-12 bg-background border border-primary-20 flex items-center justify-center">
                                <LuScanFace size={24} className="text-primary-100" />
                            </div>
                            <div className="flex flex-col gap-1">
                                {/* <label className="font-bold text-sx text-black-60">مرحله دوم:</label> */}
                                <p className="text-black-100 font-bold text-sm">بارگذاری تصویر سلفی</p>
                                <p className='text-black-60 font-medium text-xs'>
                                    یک عکس سلفی با مدرک شناسایی در دست و دست نوشته که در ادامه متن آن نوشته شده تهیه و ارسال کنید.
                                    مطمئن شوید چهره و نوشته کاملا واضح و قابل خواندن باشد.
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="rounded-full min-w-12 min-h-12 max-w-12 max-h-12 bg-background border border-primary-20 flex items-center justify-center">
                                <LuFileCheck2 size={24} className="text-primary-100" />
                            </div>
                            <div className="flex flex-col gap-1">
                                <p className="text-black-100 font-bold text-sm">بررسی و تایید مدرک</p>
                                <p className='text-black-60 font-medium text-xs'>
                                    پس از ارسال مدارک، تیم پشتیبانی صرافی مدارک شما را بررسی میکند.
                                    نتیجه احراز هویت از طریق پیامک به شما اطلاع داده خواهد شد.
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="rounded-full min-w-12 min-h-12 max-w-12 max-h-12 bg-background border border-primary-20 flex items-center justify-center">
                                <LuLifeBuoy size={24} className="text-primary-100" />
                            </div>
                            <div className="flex flex-col gap-1">
                                <p className="text-black-100 font-bold text-sm">پشتیبانی</p>
                                <p className='text-black-60 font-medium text-xs'>در صورت بروز مشکل در مراحل احراز هویت، می‌توانید از طریق گفت‌وگوی آنلاین وب‌سایت، ارسال تیکت یا تماس با پشتیبانی با تیم ما در ارتباط باشید.</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-4 mt-6">
                        <Button onClick={() => setStep(2)} className="flex-1" type="primary">
                            ادامه احراز هویت
                        </Button>
                        <Button className="flex-1 bg-background" type="text" onClick={props.onBack}>
                            بازگشت
                        </Button>
                    </div>
                </div>
            ) : (
                // step === 2 ?
                //  (
                //     <div className="flex flex-col gap-6">
                //         {/* <div className="flex items-start gap-4 flex-1 w-full">
                //             <div className="flex flex-col items-center gap-2">
                //                 <FaRegIdCard size={24} className={step >= 2 ? 'text-primary-100' : 'text-black-100'} />
                //                 <p
                //                     className={`font-bold text-sm whitespace-nowrap ${step >= 2 ? 'text-primary-100' : 'text-black-100'}`}
                //                 >
                //                     بارگذاری تصویر کارت ملی
                //                 </p>
                //             </div>
                //             <div className="h-6 w-full flex items-center justify-center">
                //                 <div className="w-full h-px bg-primary-20" />
                //             </div>
                //             <div className="flex flex-col items-center gap-2">
                //                 <LuScanFace size={24} className={step >= 3 ? 'text-primary-100' : 'text-black-100'} />
                //                 <p
                //                     className={`font-bold text-sm whitespace-nowrap ${step >= 3 ? 'text-primary-100' : 'text-black-100'}`}
                //                 >
                //                     بارگذاری تصویر سلفی
                //                 </p>
                //             </div>
                //         </div> */}
                //         <p className="text-sm font-medium text-black-100">
                //             این نوع فرایند احراز هویت به صورت دستی و طی ۱۲ ساعت انجام میشود.
                //         </p>

                //         <div className="flex flex-col gap-4">
                //             <h6 className="text-base font-bold text-darkPurple-100">جلو کارت ملی:</h6>
                //             <div className="flex items-center gap-4 max-h-[86px] h-[86px]">
                //                 <div
                //                     onClick={() => {
                //                         setActiveCamera('front');
                //                         setIsCameraModalOpen(true);
                //                     }}
                //                     className="flex-1 h-full w-full bg-white border border-primary-20 rounded-lg flex flex-col gap-3 items-center justify-center text-primary-100 clickable"
                //                 >
                //                     {frontCapturedImage ? (
                //                         <div className="rounded-lg overflow-hidden m-auto w-fit h-[80%]">
                //                             <img
                //                                 src={URL.createObjectURL(frontCapturedImage)}
                //                                 alt="Captured"
                //                                 className="h-full w-full object-contain"
                //                             />
                //                         </div>
                //                     ) : (
                //                         <>
                //                             <BsCamera size={24} />
                //                             <p className="text-sm font-medium">عکس برداری</p>
                //                         </>
                //                     )}
                //                 </div>

                //                 <div
                //                     className={`flex-1 h-full w-full bg-white border border-primary-20 rounded-lg flex flex-col gap-3 items-center justify-center text-primary-100 clickable`}
                //                     onClick={() => document.getElementById('front-file-input')?.click()}
                //                 >
                //                     {frontSelectedImage ? (
                //                         <div className="rounded-lg overflow-hidden m-auto w-fit h-[80%]">
                //                             <img
                //                                 src={URL.createObjectURL(frontSelectedImage)}
                //                                 alt="Selected"
                //                                 className="h-full w-full object-contain"
                //                             />
                //                         </div>
                //                     ) : (
                //                         <>
                //                             <BsImage size={24} />
                //                             <p className="text-sm font-medium">انتخاب فایل</p>
                //                         </>
                //                     )}
                //                 </div>
                //                 <input
                //                     id="front-file-input"
                //                     type="file"
                //                     accept=".jpg,.jpeg,.png,.heic"
                //                     style={{ display: 'none' }}
                //                     onChange={(e) => handleFileChange(e, 'front')}
                //                 />
                //             </div>
                //         </div>

                //         <div className="flex flex-col gap-4">
                //             <h6 className="text-base font-bold text-darkPurple-100">پشت کارت ملی:</h6>
                //             <div className="flex items-center gap-4 max-h-[86px] h-[86px]">
                //                 <div
                //                     onClick={() => {
                //                         setActiveCamera('back');
                //                         setIsCameraModalOpen(true);
                //                     }}
                //                     className="flex-1 h-full w-full bg-white border border-primary-20 rounded-lg flex flex-col gap-3 items-center justify-center text-primary-100 clickable"
                //                 >
                //                     {backCapturedImage ? (
                //                         <div className="rounded-lg overflow-hidden m-auto w-fit h-[80%]">
                //                             <img
                //                                 src={URL.createObjectURL(backCapturedImage)}
                //                                 alt="Captured"
                //                                 className="h-full w-full object-contain"
                //                             />
                //                         </div>
                //                     ) : (
                //                         <>
                //                             <BsCamera size={24} />
                //                             <p className="text-sm font-medium">عکس برداری</p>
                //                         </>
                //                     )}
                //                 </div>

                //                 <div
                //                     className={`flex-1 h-full w-full bg-white border border-primary-20 rounded-lg flex flex-col gap-3 items-center justify-center text-primary-100 clickable`}
                //                     onClick={() => document.getElementById('back-file-input')?.click()}
                //                 >
                //                     {backSelectedImage ? (
                //                         <div className="rounded-lg overflow-hidden m-auto w-fit h-[80%]">
                //                             <img
                //                                 src={URL.createObjectURL(backSelectedImage)}
                //                                 alt="Selected"
                //                                 className="h-full w-full object-contain"
                //                             />
                //                         </div>
                //                     ) : (
                //                         <>
                //                             <BsImage size={24} />
                //                             <p className="text-sm font-medium">انتخاب فایل</p>
                //                         </>
                //                     )}
                //                 </div>
                //                 <input
                //                     id="back-file-input"
                //                     type="file"
                //                     accept=".jpg,.jpeg,.png,.heic"
                //                     style={{ display: 'none' }}
                //                     onChange={(e) => handleFileChange(e, 'back')}
                //                 />
                //             </div>
                //         </div>

                //         <div className="flex items-center gap-4 ">
                //             <Button className="flex-1" type="primary" onClick={() => setStep(3)}>
                //                 تایید اطلاعات و ادامه
                //             </Button>
                //             <Button className="flex-1 bg-background" type="text" onClick={() => setStep(1)}>
                //                 بازگشت
                //             </Button>
                //         </div>
                //     </div>
                // ) :
                <div className="flex flex-col gap-6">
                    {/* <div className="flex items-start gap-4 flex-1 w-full">
                        <div className="flex flex-col items-center gap-2">
                            <FaRegIdCard size={24} className="text-primary-100" />
                            <p className="font-bold text-sm whitespace-nowrap text-primary-100">
                                بارگذاری تصویر کارت ملی
                            </p>
                        </div>
                        <div className="h-6 w-full flex items-center justify-center">
                            <div className="w-full h-px bg-primary-20" />
                        </div>
                        <div className="flex flex-col items-center gap-2">
                            <LuScanFace size={24} className="text-primary-100" />
                            <p className="font-bold text-sm whitespace-nowrap text-primary-100">بارگذاری تصویر سلفی</p>
                        </div>
                    </div> */}
                    <Alert variant='info' message={"مطمئن شوید چهره و نوشته کاملا واضح و قابل خواندن باشد."} />
                    {/* <p className="text-sm font-medium text-black-100">
                        مطمئن شوید چهره و نوشته کاملا واضح و قابل خواندن باشد.
                    </p> */}

                    <div className="flex flex-col gap-4">
                        <h6 className="text-base font-bold text-darkPurple-100">تصویر سلفی:</h6>
                        <div className="flex items-center gap-4 max-h-[86px] h-[86px]">
                            <div
                                onClick={() => {
                                    setActiveCamera('selfie');
                                    setIsCameraModalOpen(true);
                                }}
                                className="flex-1 h-full w-full bg-white border border-primary-20 rounded-lg flex flex-col gap-3 items-center justify-center text-primary-100 clickable"
                            >
                                {selfieCapturedImage ? (
                                    <div className="rounded-lg overflow-hidden m-auto w-fit h-[80%]">
                                        <img
                                            src={URL.createObjectURL(selfieCapturedImage)}
                                            alt="Captured"
                                            className="h-full w-full object-contain"
                                        />
                                    </div>
                                ) : (
                                    <>
                                        <BsCamera size={24} />
                                        <p className="text-sm font-medium">عکس برداری</p>
                                    </>
                                )}
                            </div>

                            <div
                                className={`flex-1 h-full w-full bg-white border border-primary-20 rounded-lg flex flex-col gap-3 items-center justify-center text-primary-100 clickable`}
                                onClick={() => document.getElementById('selfie-file-input')?.click()}
                            >
                                {selfieSelectedImage ? (
                                    <div className="rounded-lg overflow-hidden m-auto w-fit h-[80%]">
                                        <img
                                            src={URL.createObjectURL(selfieSelectedImage)}
                                            alt="Selected"
                                            className="h-full w-full object-contain"
                                        />
                                    </div>
                                ) : (
                                    <>
                                        <BsImage size={24} />
                                        <p className="text-sm font-medium">انتخاب فایل</p>
                                    </>
                                )}
                            </div>
                            <input
                                id="selfie-file-input"
                                type="file"
                                accept=".jpg,.jpeg,.png,.heic"
                                style={{ display: 'none' }}
                                onChange={(e) => handleFileChange(e, 'selfie')}
                            />
                        </div>
                    </div>
                    <div className="w-full flex items-center justify-center">
                        <Image width={300} className="rounded-md mx-auto" src={HintImage} alt="selfie-image" />
                    </div>
                    <div className='flex flex-col'>
                        <p className='text-black-100 text-base'>
                            متن دست نوشته:
                        </p>
                        <p className='text-black-60 text-sm'>
                            اینجانب {userProfile.get()?.fullName} تعهد میدهم ضمن مطالعه و تایید قوانین صرافی 30پی مسئولیت حساب کاربری خود را پذیرفته و حساب کاربری خود را تحت هیچ شرایطی در اختیار شخص دیگری قرار نخواهم داد و برای شخص دیگری خرید نمیکنم.
                            <br />
                            نام و نام خانوادگی
                            <br />
                            تاریخ روز:
                            <br />
                            امضاء:
                        </p>
                    </div >

                    {/* <div
                        // onClick={() => setShowImage(true)}
                        className="h-16 clickable w-full rounded-2xl border border-primary-20 bg-[#D7D7DC33] flex items-center justify-center gap-2"
                    >
                        <p className="font-bold text-base text-black-100 -mb-1">تصویر راهنما</p>
                        <FaImage className="text-base" />
                    </div> */}

                    <div className="flex items-center gap-4 " >
                        <Button
                            disabled={!selfieCapturedImage && !selfieSelectedImage}
                            className="flex-1"
                            type="primary"
                            onClick={handleSubmit}
                            loading={loading}
                        >
                            ثبت و ارسال مدارک
                        </Button>
                        <Button className="flex-1 bg-background" type="text" onClick={() => setStep(1)}>
                            بازگشت
                        </Button>
                    </div>
                </div >
            )}
        </>
    );
};

export default React.forwardRef(ProfileProfessionalManualVerifyModalContent);
